export const conversationalReplyRouting = "/:app_group_id/conversational/reply_routing";
